<div class="flex flex-col bg-[var(--colorGrey)] mt-8 mb-8 p-4 rounded text-[var(--color-text-strong)]">
    <div class="flex flex-col">
        <p class="font-bold">{{ title() }}</p>
        <p class="text-[rgb(var(--ui-5))] mt-2 mb-2 text-sm">{{ subtitle() }}</p>
        <div class="flex flex-row justify-between text-[rgb(var(--ui-5))] mb-2 text-sm">
            <p>
                {{ 'seasons.season-details.setting-cards.salary-card.monthly-salary-column-label' | translate }}
            </p>
            <p class="pr-5">
                {{ 'seasons.season-details.setting-cards.salary-card.weight-column-label' | translate }}
            </p>
        </div>
        @for (salaryRangeItem of salaryRangeItems(); track salaryRangeItem; let index = $index) {
            <div class="flex justify-between">
                <p>
                    {{
                        index + 1 === salaryRangeItems().length
                            ? '> ' + salaryRangeItem.lowerBound + ' EUR'
                            : salaryRangeItem.lowerBound + ' - ' + salaryRangeItem.upperBound + ' EUR'
                    }}
                </p>
                <p class="pr-8">{{ salaryRangeItem?.weight }}</p>
            </div>
            <div class="mt-2 mb-2 h-px bg-[rgb(var(--ui-6))]" aria-hidden="true"></div>
        }
    </div>
</div>
